import React from "react";
import PropTypes from "prop-types";
import { TableCell, TableRow } from "@mui/material";
import { Skeleton } from "../../../../../../components";
const MutationsTableSkeleton = ({ rows = 10, columns = 4 }) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, Array.from({ length: rows }).map((_, idx) => /* @__PURE__ */ React.createElement(TableRow, { key: idx }, Array.from({ length: columns }).map((_2, colIdx) => /* @__PURE__ */ React.createElement(TableCell, { key: colIdx }, /* @__PURE__ */ React.createElement(Skeleton, null))))));
};
MutationsTableSkeleton.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number
};
export default MutationsTableSkeleton;
